import * as React from "react";

export function useIntervalToRerender(intervalInMs: number) {
    const [currentTime, setCurrentTime] = React.useState(new Date());

    React.useEffect(() => {
        const intervalId = window.setInterval(() => {
            setCurrentTime(new Date());
        }, intervalInMs);

        return () => window.clearInterval(intervalId);
    }, []);
    
    return currentTime;
}
